module.exports = __webpack_public_path__ + "static/media/author5.c37d1aa3.jpg";